module.exports = __webpack_public_path__ + "img/tips-water.aa31498b.svg";